var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { useTranslation } from "react-i18next";
import RepeatableEntityConfig from "./RepeatableEntityConfig";
import { ServiceService } from "../../services/service/service.service";
import { addMinutes, diffInMinutes } from "../../utils/date.util";
import { AvailabilityService } from "../../services/availability/availability.service";
import AvailabilityChangesDialog from "./AvailabilityChangesDialog";
import { AvailabilityExceptionService } from "../../services/availability/availabilityException.service";
import CColorPicker from "../CColorPicker";
import { AvailabilityType } from "../../models/availability/availability.model";
import { CommonThemeColors } from "../theme";
import CountTextField from "../CountTextField";
import { useReadOnly } from "../../utils/hooks/users/useReadOnly";
import { pickSeriesChanges, updateSeriesFromOccurrence } from "./availabilitySeriesUpdate";
var CAPACITY_COLOR = "#191a1a";
var AvailabilityDialog = function (props) {
    var _a, _b, _c, _d;
    var t = useTranslation().t;
    // Read-only users can open a slot to view it, but not edit, save or delete it.
    var readOnly = useReadOnly();
    // Make every field in the dialog body non-interactive for read-only users — including the
    // date/time pickers and recurrence config inside RepeatableEntityConfig, which are not
    // plain MUI inputs. `inert` removes the whole subtree from focus/pointer handling.
    var contentRef = useRef(null);
    useEffect(function () {
        if (contentRef.current) {
            contentRef.current.inert = readOnly;
        }
    }, [readOnly, props.open]);
    var _e = useState(props.availability), availability = _e[0], setAvailability = _e[1];
    var _f = useState(props.availability), originalAvailability = _f[0], setOriginalAvailability = _f[1];
    var _g = useState(false), changesDialogOpen = _g[0], setChangesDialogOpen = _g[1];
    var _h = useState('save'), requestedAction = _h[0], setRequestedAction = _h[1];
    var changeOptions = ['current', 'all'];
    if ((originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.rrule) && (originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.rrule) != (availability === null || availability === void 0 ? void 0 : availability.rrule)) {
        changeOptions = ['all'];
    }
    var _j = useState(((_a = props.availability) === null || _a === void 0 ? void 0 : _a.capacityOverride) !== undefined && ((_b = props.availability) === null || _b === void 0 ? void 0 : _b.capacityOverride) !== null), capacityEnabled = _j[0], setCapacityEnabled = _j[1];
    var getDefaultColor = function (type) {
        if (type === AvailabilityType.CLOSED)
            return CommonThemeColors.sys.availability.boldRed;
        return CommonThemeColors.sys.availability.boldBlue;
    };
    useEffect(function () {
        var _a;
        if (props.open) {
            var next = props.availability;
            var enabled = (next === null || next === void 0 ? void 0 : next.capacityOverride) !== undefined && (next === null || next === void 0 ? void 0 : next.capacityOverride) !== null;
            setCapacityEnabled(enabled);
            setAvailability(next ? __assign(__assign({}, next), { color: (_a = next.color) !== null && _a !== void 0 ? _a : getDefaultColor(next.type) }) : next);
            setOriginalAvailability(props.availability);
            setLocalSelectedServices([]);
        }
    }, [props.availability, props.open]);
    var isClosed = (availability === null || availability === void 0 ? void 0 : availability.type) === AvailabilityType.CLOSED;
    var handleToggleCapacity = function (enabled) {
        setCapacityEnabled(enabled);
        setAvailability(function (prev) {
            var _a, _b;
            var prevColor = (_a = prev === null || prev === void 0 ? void 0 : prev.color) !== null && _a !== void 0 ? _a : getDefaultColor(prev === null || prev === void 0 ? void 0 : prev.type);
            var defaultColor = getDefaultColor(prev === null || prev === void 0 ? void 0 : prev.type);
            if (enabled) {
                // const nextColor = prevColor === defaultColor ? CAPACITY_COLOR : prevColor;
                return __assign(__assign({}, prev), { capacityOverride: (_b = prev === null || prev === void 0 ? void 0 : prev.capacityOverride) !== null && _b !== void 0 ? _b : 0 });
            }
            else {
                // const nextColor = prevColor === CAPACITY_COLOR ? defaultColor : prevColor;
                return __assign(__assign({}, prev), { capacityOverride: undefined });
            }
        });
    };
    var addAvailabilityMut = useMutation(['addAvailability', availability, props.entityId], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AvailabilityService.createAvailability(__assign(__assign({}, availability), { entityId: props.entityId }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, {
        onSuccess: function (availability) { return __awaiter(void 0, void 0, void 0, function () {
            var selectedServiceIds, availId, resourceId, _i, _a, service, isSelected, updatedBindings;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_b = props === null || props === void 0 ? void 0 : props.setCurrentAvailability) === null || _b === void 0 ? void 0 : _b.call(props, availability);
                        if (!(localSelectedServices.length > 0 && props.entityId)) return [3 /*break*/, 6];
                        selectedServiceIds = new Set(localSelectedServices.map(function (s) { return s.id; }));
                        availId = availability.id;
                        resourceId = props.entityId;
                        _i = 0, _a = props.weeklyPlannerServices;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        service = _a[_i];
                        isSelected = selectedServiceIds.has(service.id);
                        if (!isSelected) return [3 /*break*/, 3];
                        updatedBindings = __spreadArray(__spreadArray([], (service.availabilityBindings || []), true), [
                            {
                                resourceId: resourceId,
                                availabilityName: availability.name || '',
                                availabilityIds: [availId]
                            }
                        ], false);
                        return [4 /*yield*/, ServiceService.updateService(__assign(__assign({}, service), { availabilityBindings: updatedBindings }))];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, queryClient.refetchQueries({ queryKey: ['allServices'], exact: false })];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        props.onConfirm();
                        props === null || props === void 0 ? void 0 : props.onClose();
                        return [2 /*return*/];
                }
            });
        }); },
        onError: function (error) {
            console.error('Failed to add availability:', error);
        }
    });
    var updateAvailabilityMut = useMutation(['updateAvailability', availability, props.entityId], function () { return __awaiter(void 0, void 0, void 0, function () {
        var timesChanged, diffStart, diffEnd, updatedAvailability, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.rrule)) return [3 /*break*/, 2];
                    timesChanged = diffInMinutes(availability === null || availability === void 0 ? void 0 : availability.startTime, originalAvailability.startTime) !== 0
                        || diffInMinutes(availability === null || availability === void 0 ? void 0 : availability.endTime, originalAvailability.endTime) !== 0;
                    return [4 /*yield*/, updateSeriesFromOccurrence({
                            occurrence: originalAvailability,
                            newStart: timesChanged ? availability === null || availability === void 0 ? void 0 : availability.startTime : undefined,
                            newEnd: timesChanged ? availability === null || availability === void 0 ? void 0 : availability.endTime : undefined,
                            // The dialog fills in the default color on open - that alone is not a change
                            changes: pickSeriesChanges(__assign(__assign({}, originalAvailability), { color: (_a = originalAvailability.color) !== null && _a !== void 0 ? _a : getDefaultColor(originalAvailability.type) }), availability),
                        })];
                case 1:
                    _b.sent();
                    props.onConfirm();
                    props.onClose();
                    setChangesDialogOpen(false);
                    return [2 /*return*/];
                case 2:
                    diffStart = diffInMinutes(availability === null || availability === void 0 ? void 0 : availability.startTime, originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.startTime);
                    diffEnd = diffInMinutes(availability === null || availability === void 0 ? void 0 : availability.endTime, originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.endTime);
                    updatedAvailability = __assign(__assign({}, availability), { id: availability === null || availability === void 0 ? void 0 : availability.availabilityId, entityId: props.entityId, startTime: addMinutes(originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.originalStartTime, diffStart), endTime: addMinutes(originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.originalEndTime, diffEnd) });
                    return [4 /*yield*/, AvailabilityService.updateAvailability(updatedAvailability)];
                case 3:
                    response = _b.sent();
                    props.onConfirm();
                    props.onClose();
                    setChangesDialogOpen(false);
                    return [2 /*return*/, response];
            }
        });
    }); });
    var createExceptionMut = useMutation(['createAvailabilityException', availability, props.entityId], function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(availability === null || availability === void 0 ? void 0 : availability.exceptionId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, AvailabilityExceptionService.update({
                            id: availability === null || availability === void 0 ? void 0 : availability.exceptionId,
                            availabilityId: availability === null || availability === void 0 ? void 0 : availability.availabilityId,
                            originalStartTime: originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.occurrenceStartTime,
                            newStartTime: availability === null || availability === void 0 ? void 0 : availability.startTime,
                            newEndTime: availability === null || availability === void 0 ? void 0 : availability.endTime,
                            name: availability === null || availability === void 0 ? void 0 : availability.name,
                            color: availability === null || availability === void 0 ? void 0 : availability.color,
                            deleted: requestedAction === 'delete',
                            capacityOverride: availability === null || availability === void 0 ? void 0 : availability.capacityOverride,
                            type: availability === null || availability === void 0 ? void 0 : availability.type,
                        })];
                case 1:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, AvailabilityExceptionService.create({
                        availabilityId: availability === null || availability === void 0 ? void 0 : availability.availabilityId,
                        originalStartTime: availability === null || availability === void 0 ? void 0 : availability.occurrenceStartTime,
                        newStartTime: availability === null || availability === void 0 ? void 0 : availability.startTime,
                        newEndTime: availability === null || availability === void 0 ? void 0 : availability.endTime,
                        name: availability === null || availability === void 0 ? void 0 : availability.name,
                        color: availability === null || availability === void 0 ? void 0 : availability.color,
                        deleted: requestedAction === 'delete',
                        capacityOverride: availability === null || availability === void 0 ? void 0 : availability.capacityOverride,
                        type: availability === null || availability === void 0 ? void 0 : availability.type,
                    })];
                case 3:
                    result = _a.sent();
                    _a.label = 4;
                case 4:
                    props.onConfirm();
                    props.onClose();
                    setChangesDialogOpen(false);
                    return [2 /*return*/, result];
            }
        });
    }); });
    var deleteAvailabilityMut = useMutation(['deleteAvailability', availability], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AvailabilityService.deleteAvailability({
                        id: [availability === null || availability === void 0 ? void 0 : availability.availabilityId]
                    })];
                case 1:
                    _a.sent();
                    props.onDeleted();
                    props.onClose();
                    setChangesDialogOpen(false);
                    return [2 /*return*/];
            }
        });
    }); });
    var _k = useState([]), localSelectedServices = _k[0], setLocalSelectedServices = _k[1];
    var selectedServices = (availability === null || availability === void 0 ? void 0 : availability.availabilityId)
        ? props.weeklyPlannerServices.filter(function (service) {
            var _a;
            if (!props.entityId || !(availability === null || availability === void 0 ? void 0 : availability.availabilityId))
                return false;
            return (_a = service.availabilityBindings) === null || _a === void 0 ? void 0 : _a.some(function (binding) {
                var _a;
                return binding.resourceId === props.entityId &&
                    ((_a = binding.availabilityIds) === null || _a === void 0 ? void 0 : _a.includes(availability.availabilityId));
            });
        })
        : localSelectedServices;
    var queryClient = useQueryClient();
    var updateServiceBindingsMut = useMutation(['updateServiceBindings'], function (selectedServices) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedServiceIds, availId, resourceId, _i, _a, service, isSelected, existingBinding, updatedBindings, updatedBindings;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!props.entityId || !(availability === null || availability === void 0 ? void 0 : availability.availabilityId))
                        return [2 /*return*/];
                    selectedServiceIds = new Set(selectedServices.map(function (s) { return s.id; }));
                    availId = availability.availabilityId;
                    resourceId = props.entityId;
                    _i = 0, _a = props.weeklyPlannerServices;
                    _c.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    service = _a[_i];
                    isSelected = selectedServiceIds.has(service.id);
                    existingBinding = (_b = service.availabilityBindings) === null || _b === void 0 ? void 0 : _b.find(function (b) { var _a; return b.resourceId === resourceId && ((_a = b.availabilityIds) === null || _a === void 0 ? void 0 : _a.includes(availId)); });
                    if (!(isSelected && !existingBinding)) return [3 /*break*/, 3];
                    updatedBindings = __spreadArray(__spreadArray([], (service.availabilityBindings || []), true), [
                        {
                            resourceId: resourceId,
                            availabilityName: availability.name || '',
                            availabilityIds: [availId]
                        }
                    ], false);
                    return [4 /*yield*/, ServiceService.updateService(__assign(__assign({}, service), { availabilityBindings: updatedBindings }))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!(!isSelected && existingBinding)) return [3 /*break*/, 5];
                    updatedBindings = service.availabilityBindings.filter(function (b) { var _a; return !(b.resourceId === resourceId && ((_a = b.availabilityIds) === null || _a === void 0 ? void 0 : _a.includes(availId))); });
                    return [4 /*yield*/, ServiceService.updateService(__assign(__assign({}, service), { availabilityBindings: updatedBindings }))];
                case 4:
                    _c.sent();
                    _c.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    queryClient.refetchQueries({ queryKey: ['allServices'], exact: false });
                    return [2 /*return*/];
            }
        });
    }); });
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, __assign({ open: props.open, onClose: props.onClose }, { children: [_jsx(DialogTitle, { children: t("Availability") }), _jsx(DialogContent, { children: _jsxs(Box, __assign({ ref: contentRef, sx: {
                                width: "100%",
                                gap: "32px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flexStart",
                                mb: 2,
                                flex: 1,
                                pt: 1,
                                opacity: readOnly ? 0.6 : undefined
                            } }, { children: [_jsx(RepeatableEntityConfig, { entity: availability, setEntity: setAvailability, onClear: function () { return handleToggleCapacity(false); }, disabled: readOnly }), _jsxs(Box, __assign({ sx: { width: '100%' } }, { children: [_jsx(Typography, __assign({ variant: "h6", sx: { mb: 1 } }, { children: t("Type and Color") })), _jsxs(FormControl, __assign({ fullWidth: true, size: "small", sx: { mb: 1.5 } }, { children: [_jsx(InputLabel, __assign({ id: "availability-type-label" }, { children: t("Availability Type") })), _jsx(Select, __assign({ labelId: "availability-type-label", id: "availability-type", label: t("Availability Type"), disabled: readOnly, value: (availability === null || availability === void 0 ? void 0 : availability.type) || AvailabilityType.OPEN, onChange: function (e) {
                                                        var nextType = e.target.value;
                                                        setAvailability(function (prev) {
                                                            var _a;
                                                            var prevColor = (_a = prev === null || prev === void 0 ? void 0 : prev.color) !== null && _a !== void 0 ? _a : getDefaultColor(prev === null || prev === void 0 ? void 0 : prev.type);
                                                            var wasClosed = (prev === null || prev === void 0 ? void 0 : prev.type) === AvailabilityType.CLOSED;
                                                            var nextDefault = getDefaultColor(nextType);
                                                            var nextColor = prevColor;
                                                            if (nextType === AvailabilityType.CLOSED) {
                                                                nextColor = CommonThemeColors.sys.availability.boldRed;
                                                            }
                                                            else {
                                                                if (wasClosed && prevColor === CommonThemeColors.sys.availability.boldRed) {
                                                                    nextColor = nextDefault;
                                                                }
                                                                else if (capacityEnabled && prevColor === CAPACITY_COLOR) {
                                                                    nextColor = CAPACITY_COLOR;
                                                                }
                                                                else if (prevColor === getDefaultColor(prev === null || prev === void 0 ? void 0 : prev.type)) {
                                                                    nextColor = nextDefault;
                                                                }
                                                            }
                                                            return __assign(__assign({}, prev), { type: nextType, color: nextColor });
                                                        });
                                                        if (nextType === AvailabilityType.CLOSED) {
                                                            setCapacityEnabled(false);
                                                        }
                                                    } }, { children: Object.values(AvailabilityType).map(function (type, index) { return (_jsx(MenuItem, __assign({ value: type, id: "availability-type-".concat(type) }, { children: type ? t("Availability Type ".concat(type)) : t("(Not set)") }), index)); }) }))] })), _jsx(CColorPicker, { value: isClosed
                                                ? CommonThemeColors.sys.availability.boldRed
                                                : (_c = availability === null || availability === void 0 ? void 0 : availability.color) !== null && _c !== void 0 ? _c : getDefaultColor(availability === null || availability === void 0 ? void 0 : availability.type), onChange: function (e) {
                                                setAvailability(__assign(__assign({}, availability), { color: e }));
                                            }, size: "small", disabled: isClosed || readOnly })] })), props.weeklySector && (_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "h6", sx: { mb: 0.5 } }, { children: t("Weekly Planner Assignments") })), _jsx(Typography, __assign({ variant: "body2", sx: { mb: 1.5 } }, { children: t("To which services this availability applies in the weekly planner.") })), _jsx(Autocomplete, { id: "services", options: props.weeklyPlannerServices, multiple: true, disabled: readOnly, getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.name) || ""; }, value: selectedServices, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { fullWidth: true, size: "small", label: t("Assigned Services") }))); }, fullWidth: true, onChange: function (e, value) {
                                                if (availability === null || availability === void 0 ? void 0 : availability.availabilityId) {
                                                    updateServiceBindingsMut.mutate(value);
                                                }
                                                else {
                                                    setLocalSelectedServices(value);
                                                }
                                            } })] })), props.weeklySector && (_jsxs(Box, __assign({ sx: { width: '100%' } }, { children: [_jsx(Typography, __assign({ variant: "h6", sx: { mb: 0.5 } }, { children: t("Capacity Override") })), _jsx(Typography, __assign({ variant: "body2", sx: { mb: 1.5 } }, { children: isClosed
                                                ? t("Capacity override is not available when availability is closed.")
                                                : t("If set, this overrides the resource capacity for the selected time.") })), _jsx(FormControlLabel, { control: _jsx(Switch, { checked: capacityEnabled && !isClosed, onChange: function (e) { return handleToggleCapacity(e.target.checked); }, disabled: isClosed || readOnly }), label: t("Enable Capacity Override"), sx: { mb: 1 } }), _jsx(FormControl, __assign({ fullWidth: true, size: "small", disabled: !capacityEnabled || isClosed || readOnly }, { children: _jsx(CountTextField, { size: "small", fullWidth: true, disabled: !capacityEnabled || isClosed || readOnly, value: capacityEnabled ? String((_d = availability === null || availability === void 0 ? void 0 : availability.capacityOverride) !== null && _d !== void 0 ? _d : 0) : "", onChangeValue: function (value) {
                                                    return setAvailability(function (prev) { return (__assign(__assign({}, prev), { capacityOverride: value === undefined ? undefined : Math.max(0, Math.trunc(Number(value))) })); });
                                                }, inputProps: { min: 0, style: { textAlign: "center" } } }) }))] })))] })) }), _jsxs(DialogActions, { children: [_jsx(LoadingButton, __assign({ variant: "text", color: "error", onClick: function () {
                                    if (!(availability === null || availability === void 0 ? void 0 : availability.rrule)) {
                                        deleteAvailabilityMut.mutate();
                                    }
                                    else {
                                        setRequestedAction("delete");
                                        setChangesDialogOpen(true);
                                    }
                                }, startIcon: _jsx(DeleteIcon, {}), loading: deleteAvailabilityMut.isLoading, disabled: readOnly }, { children: t("Delete") })), _jsx(LoadingButton, __assign({ variant: "contained", color: "primary", onClick: function () {
                                    console.log('originalAvailability:', originalAvailability);
                                    if (!(originalAvailability === null || originalAvailability === void 0 ? void 0 : originalAvailability.rrule)) {
                                        console.log('availability to save:', availability);
                                        if (availability === null || availability === void 0 ? void 0 : availability.id) {
                                            updateAvailabilityMut.mutate();
                                        }
                                        else {
                                            console.log('adding');
                                            addAvailabilityMut.mutate();
                                        }
                                    }
                                    else {
                                        setRequestedAction("save");
                                        setChangesDialogOpen(true);
                                    }
                                }, startIcon: _jsx(SaveIcon, {}), loading: updateAvailabilityMut.isLoading, disabled: readOnly }, { children: t("Save") }))] })] })), _jsx(AvailabilityChangesDialog, { open: changesDialogOpen, onClose: function () { return setChangesDialogOpen(false); }, onPick: function (option) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (requestedAction === "delete") {
                            if (option === "all") {
                                deleteAvailabilityMut.mutate();
                            }
                            else {
                                createExceptionMut.mutate();
                            }
                        }
                        else {
                            if (option === "all") {
                                updateAvailabilityMut.mutate();
                            }
                            else if (option === "current") {
                                createExceptionMut.mutate();
                            }
                        }
                        setRequestedAction("save");
                        return [2 /*return*/];
                    });
                }); }, changeOptions: changeOptions })] }));
};
export default AvailabilityDialog;
